// extracted by mini-css-extract-plugin
export default {"form":"c1_bN8Mmg","inputContainer":"cx86vEynA","additionalInfo":"cuTy9uH4m","innerContainer":"czNrVxvn0"};